import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Edit2, Trash2 } from 'lucide-react';
import type { Tag } from '../types';

interface TagContextMenuProps {
  tag: Tag;
  position: { x: number; y: number };
  onClose: () => void;
  onEdit: (tag: Tag) => void;
  onDelete: (tag: Tag) => void;
}

const TagContextMenu: React.FC<TagContextMenuProps> = ({
  tag,
  position,
  onClose,
  onEdit,
  onDelete
}) => {
  React.useEffect(() => {
    const handleClick = () => onClose();
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [onClose]);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        style={{ top: position.y, left: position.x }}
        className="fixed z-50 w-48 bg-background border rounded-md shadow-lg py-1"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => {
            onEdit(tag);
            onClose();
          }}
          className="w-full px-3 py-2 text-sm flex items-center gap-2 hover:bg-muted transition-colors"
        >
          <Edit2 className="w-4 h-4" />
          Edit Tag
        </button>
        <button
          onClick={() => {
            onDelete(tag);
            onClose();
          }}
          className="w-full px-3 py-2 text-sm flex items-center gap-2 text-destructive hover:bg-destructive/10 transition-colors"
        >
          <Trash2 className="w-4 h-4" />
          Delete Tag
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default TagContextMenu;